// Single source of truth for the 4 game types stored on Grid.type (1-4).
// Every games/* page reads from here instead of hardcoding type numbers,
// labels, share-link path segments or colors - adding a 5th game type
// someday means adding one entry here, not a whole new page.
const GAME_HOST = 'https://games.english-from-zero.ovh';

const GAME_TYPES = {
   1: {
      type: 1, key: 'grid', label: 'Числова сітка', hasAnswer: false,
      playPathSegment: 'grid', accent: '#4f8ef7',
      valueLabel: 'Значення', valuePlaceholder: 'Наприклад: 42',
   },
   2: {
      type: 2, key: 'quiz', label: 'Квіз', hasAnswer: true,
      playPathSegment: 'quiz', accent: '#c084fc',
      valueLabel: 'Питання', valuePlaceholder: 'Текст питання',
      answerLabel: 'Відповідь', answerPlaceholder: 'Правильна відповідь',
   },
   3: {
      type: 3, key: 'letters', label: 'Слова', hasAnswer: false,
      playPathSegment: 'word', accent: '#34d399',
      valueLabel: 'Слово', valuePlaceholder: 'Наприклад: apple',
   },
   4: {
      type: 4, key: 'matching', label: 'Підбір пар', hasAnswer: true,
      playPathSegment: 'matching-gaps', accent: '#fb923c',
      valueLabel: 'Слово', valuePlaceholder: 'Слово з пропуском',
      answerLabel: 'Пара', answerPlaceholder: 'Відповідне слово',
   },
};

export const GAME_TYPE_LIST = Object.values(GAME_TYPES);

export function getGameType(type) {
   return GAME_TYPES[Number(type)] || GAME_TYPES[1];
}

// "Prefix" variants (URL up to and including "?id=") exist because the
// generic Icon component (components/tables/Icon.jsx) builds copy-url/
// copy-iframe links as `clearurl + item[urlfield]` - it wants the prefix,
// not a finished URL.
export function gamePlayUrlPrefix(type) {
   return GAME_HOST + '/' + getGameType(type).playPathSegment + '?id=';
}

export function setPlayUrlPrefix() {
   return GAME_HOST + '/set?id=';
}

export function gamePlayUrl(type, id) {
   return gamePlayUrlPrefix(type) + id;
}

export function setPlayUrl(id) {
   return setPlayUrlPrefix() + id;
}

export default GAME_TYPES;
